/**
 * @file: 拖拽
 * @author: xiaolong.huang@dmall.com
 */

let dragMap: Map<CubeId, DragCubeNode> = new Map();

export function __get__(cubeId: CubeId): DragCubeNode {
    return dragMap.get(cubeId);
}

export function __delete__(cubeId: CubeId): void {
    dragMap.delete(cubeId);
}

export function __add__(cubeId: CubeId, dragInstance: DragCubeNode): void {
    dragMap.set(cubeId, dragInstance);
}

export function __clear__(): void {
    dragMap.clear();
}

export function __has__(cubeId: CubeId): boolean {
    return dragMap.has(cubeId);
}
